<template>
  <button :type="buttonType" class="ladda-button btn" :class="classObject" @click.prevent="click" data-style="slide-left">
    <span class="ladda-label"><slot></slot></span>
  </button>
</template>

<script>
  import ladda from 'ladda'

  export default {
    props: {
      onClick: {
        required: true,
        type: Function
      },
      arguments: {
        required: false,
        type: Array,
        default () {
          return []
        }
      },
      buttonType: {
        required: false,
        type: String,
        default: 'button'
      },
      type: {
        required: false,
        type: String,
        default: 'primary'
      },
      delay: {
        required: false,
        type: Number,
        default: 500
      },
      maxWidth: {
        required: false,
        type: Boolean,
        default: false
      },
      size: {
        required: false,
        type: String,
        default: ''
      }
    },

    computed: {
      /**
       * The class object for the button.
       *
       * @return object
       */
      classObject () {
        return {
          'btn-primary': this.type === 'primary',
          'btn-success': this.type === 'success',
          'btn-danger': this.type === 'danger',
          'btn-warning': this.type === 'warning',
          'btn-default': this.type === 'default',
          'btn-info': this.type === 'info',
          'btn-lg': this.size === 'large',
          'btn-sm': this.size === 'small',
          'btn-xs': this.size === 'xsmall',
          'btn-block': this.maxWidth
        }
      }
    },

    data () {
      return {
        instance: null
      }
    },

    /**
     * When mounted we create the Ladda instance.
     *
     * @return void
     */
    mounted () {
      this.instance = ladda.create(this.$el)
    },

    methods: {
      /**
       * When the button is clicked we start the Ladda button then pass all the
       * desired arguments into the "onClick" handler.
       *
       * @return {[type]}
       */
      click () {
        this.instance.start()
        this.onClick(...this.arguments).then(this.stop).catch(this.stop)
      },

      /**
       * Stop the instance after a given delay.
       *
       * @return void
       */
      stop () {
        setTimeout(this.instance.stop, this.delay)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LaddaButton.vue?1e42da2f